
import axios from "axios";

export const baseUrl = import.meta.env.VITE_BASE_URL;

const api = axios.create({ baseURL: baseUrl, withCredentials: true });

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(error);

    // Don't show alerts for 404 status codes
    if (error.response && error.response.status !== 404) {
      let errorPayload = null;
      try {
        errorPayload = error.response.data.errors[0].message;
      } catch (e) {
        // Ignore error parsing errors
      }
      const message = `Ein Fehler ist aufgetreten: ${errorPayload ?? error.message}`;
      alert(message);
    }

    if (error.statusCode === 401) {
      localStorage.removeItem("technician");
      // We'll handle this in the store directly
    }
    return Promise.reject(error);
  },
);

// The unified API service that will be exported
const apiService = {
  // Core HTTP methods
  get: async (url: string) => {
    return api.get(url);
  },

  post: async (url: string, data: any) => {
    return api.post(url, data);
  },

  put: async (url: string, data: any) => {
    return api.put(url, data);
  },

  delete: async (url: string) => {
    return api.delete(url);
  },

  head: async (url: string) => {
    return api.head(url);
  },

  // Specialized methods
  sendDocument: async (file: File, uploadEndpoint: string, options?: { onUploadProgress?: (progressEvent: any) => void }) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(uploadEndpoint, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
      onUploadProgress: options?.onUploadProgress || ((progressEvent) => {
        // Default progress handler if none provided
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log(`Upload progress: ${percentCompleted}%`);
      })
    });
  },

  createDevice: async (deviceData: any) => {
    // Build the flattened payload with camelCase prefixes
    const payload = {
      taximeterVendor: deviceData.taximeterVendor,
      taximeterType: deviceData.taximeterType,
      taximeterSerial: parseInt(deviceData.taximeterSerial),
      taximeterYearOfProduction: parseInt(deviceData.taximeterYearOfProduction),
      deviceVendor: deviceData.deviceVendor || deviceData.taximeterVendor,
      deviceType: deviceData.deviceType || deviceData.taximeterType,
      deviceSerial: deviceData.deviceSerial ? parseInt(deviceData.deviceSerial) : parseInt(deviceData.taximeterSerial),
      deviceYearOfProduction: deviceData.deviceYearOfProduction ? parseInt(deviceData.deviceYearOfProduction) : parseInt(deviceData.taximeterYearOfProduction)
    };

    return apiService.post(`/devices`, payload);
  },

  createInstallation: async (customerNumber: string | number, data: any) => {
    return apiService.post(`/customers/${customerNumber}/installations`, data);
  },
};

export default apiService;
